<template>
  <div id="app" class="h-100">
    <div
      v-if="stage !== 'prod' && featureToggle['show-fixed-i18n-button']"
      class="locale-box"
    >
      <b-dropdown
        variant="light"
        size="sm"
        no-caret
        class="font-weight-bold m-3 login-locale"
      >
        <template #button-content>
          <div class="d-flex align-items-center">
            <i class="icon-world text-24 mr-1"></i>
            {{ localeName }}
          </div>
        </template>
        <template v-for="locale in localeList">
          <b-dropdown-item
            :key="locale.code"
            @click="changeLocale(locale.code)"
          >
            {{ locale.name }}
          </b-dropdown-item>
        </template>
      </b-dropdown>
    </div>
    <!-- <div
      class="back-btn position-absolute"
      style="bottom: 0; right: 0; z-index: 999999"
    >
      {{ BackEvent.backEventBus }}
      android測試按鈕
    </div> -->
    <data-loading v-if="isLoading"></data-loading>
    <PassAnimation
      v-if="isPassAnimation && viewMode === 'phone'"
      :leave="isLeave"
      :mode="passAnimationMode"
      :game-mode="passAnimationGameMode"
      @animation-end="destoryPassAnimation"
    ></PassAnimation>

    <Sidebar v-if="isLogin"></Sidebar>

    <div
      :class="$device.isMobile ? 'flex-column' : 'flex-row-reverse'"
      class="h-100 overflow-hidden d-flex"
    >
      <main id="main">
        <transition :name="$device.isMobile ? transitionName : ''">
          <keep-alive :include="keepAliveRoute" max="1">
            <router-view></router-view>
          </keep-alive>
        </transition>
      </main>
      <navigation />
      <system-info></system-info>
    </div>

    <Offline />

    <modal-confirm
      v-model="isRedirectModalShow"
      :hide-cancel="true"
      :no-close="true"
      @confirm="
        isRedirectModalShow = false;
        $router.push('/');
      "
    >
      {{ $t('此頁面無法重複開啟，按確定後自動跳至首頁') }}
    </modal-confirm>
    <modal-confirm
      v-model="isLogoutModalShow"
      :hide-cancel="true"
      :no-close="true"
      @confirm="
        isLogoutModalShow = false;
        logout();
      "
    >
      {{ $t('已有其他使用者登入') }}
    </modal-confirm>
    <modal-confirm
      v-model="isLogoutOtherModalShow"
      confirm-text="登入其他帳號"
      cancel-text="將他人登出"
      :no-close="true"
      @confirm="
        isLogoutOtherModalShow = false;
        logout();
      "
      @cancel="
        isLogoutOtherModalShow = false;
        logoutOtherAccount();
      "
    >
      {{ $t('已有其他使用者登入本帳號') }}
    </modal-confirm>
    <modal-confirm
      v-model="isNewAppModalShow"
      :hide-cancel="true"
      :no-close="true"
      @confirm="openAppStore"
    >
      {{ $t('有新版本，請至商店下載更新') }}
    </modal-confirm>
    <!-- 觀戰對局結束modal -->
    <modal-confirm
      :value="isSpectateOverShow"
      :confirm-text="$t('知道了')"
      :hide-cancel="true"
      @confirm="isSpectateOverShow = false"
    >
      <template>
        <div>{{ $t('對局已結束') }}</div>
      </template>
    </modal-confirm>
    <!-- 模擬檢定modal -->
    <modal-confirm
      :value="isVerificationModalShow"
      :has-btn-close="isVerificationTimeOut"
      :confirm-text="$t('前往')"
      :cancel-text="$t('略過')"
      :hide-cancel="isVerificationTimeOut"
      :no-close="false"
      @confirm="go2Verification"
      @cancel="skipVerificationModal"
      @close="isVerificationModalShow = false"
    >
      <template>
        <div>{{ verificationModalText }}</div>
      </template>
    </modal-confirm>
    <!-- 初始棋力測驗進行中modal -->
    <modal-confirm
      :value="isRankTestModalShow"
      :has-btn-close="false"
      :confirm-text="$t('前往')"
      :cancel-text="$t('略過')"
      :hide-cancel="false"
      :no-close="false"
      @confirm="go2RankTest"
      @cancel="skipRankTestModal"
      @close="isRankTestModalShow = false"
    >
      <template>
        <div>{{ $t('初始棋力尚未結束，要前往完成嗎？') }}</div>
      </template>
    </modal-confirm>

    <!-- 首次登入，需輸入暱稱 -->
    <ModalFirstLogin :show="isFirstLogin" />

    <!-- MGM 邀請碼領獎完成後彈出的獎勵 modal（跨頁，等離開 rank-test 流程才顯示） -->
    <ModalPrize
      :show="shouldShowPrize"
      :vip-months="pendingPrize ? pendingPrize.months : 1"
      :vip-days="pendingPrize ? pendingPrize.days : 31"
      @close="closePrizeModal"
    />

    <landscape-reminder
      v-if="!$device.isMobile && !noLandscapeReminder"
    ></landscape-reminder>
    <SwitchCourse
      :visible="isSwitchCourseSheetShow"
      @close="closeSwitchCourseSheet"
    ></SwitchCourse>
    <locale-sheet></locale-sheet>
    <LadderRankSidebar />

    <ModalPostQuestion ref="modalPostQuestion" />
    <ModalVip />
    <ModalCaption />
    <UpdateProgressBar />

    <ModalSelectPvpAction />
    <ModalCreatePvp />
    <ModalJoinPvp />
    <ModalAiChat />
    <ModalTimeError v-if="isTimeError" @confirm="isTimeError = false" />
    <LiveCoursePreviewModal />
  </div>
</template>

<script>
import featureToggle from '@/constant/featureToggle.js';
import {mapActions, mapState} from 'vuex';
import watchMixin from '@/mixin/watch';
import Navigation from '@/components/Base/Navigation.vue';
import SystemInfo from '@/components/SystemInfo';
import ModalConfirm from '@/components/Modal/ModalConfirm.vue';
import {
  getLocalData,
  saveLocalData,
  getDataWithExpiry,
  setTemporaryData,
} from '@/lib/base/localData';
import {manifest, appConfigs, stage} from '@/constant/env.js';
import url from '@/lib/api/url';
import axios from 'axios';
import DataLoading from '@/components/Base/DataLoading.vue';
import PassAnimation from '@/components/Base/PassAnimation.vue';
import Sidebar from '@/components/Base/Sidebar';
import Offline from '@/components/Base/Offline.vue';
import delay from '@/lib/base/delay.js';
import {App} from '@capacitor/app';
import {Toast} from '@capacitor/toast';
import {Device} from '@capacitor/device';
import socket from '@/lib/socket/authSocket.js';
import SoundService from '@/lib/base/soundService';
import AppEvent from '@/lib/base/appEvent.js';
import BackEvent from '@/lib/base/backEvent.js';
import {throttle} from 'lodash';
import fbTrack from '@/lib/base/fbTrack';
import SwitchCourse from '@/components/Base/SwitchCourse';
import ModalFirstLogin from '@/components/Modal/ModalFirstLogin.vue';
import ModalPrize from '@/components/Modal/ModalPrize.vue';
import ModalVip from '@/components/Modal/ModalVip.vue';
import Egg from '@/lib/base/egg';
import LocaleSheet from '@/components/Base/LocaleSheet.vue';
import i18n from '@/i18n/index.js';
import ModalPostQuestion from '@/components/Modal/ModalPostQuestion.vue';
import UpdateProgressBar from '@/components/Home/UpdateProgressBar.vue';
import LadderRankSidebar from '@/components/Ladder/LadderRankSidebar.vue';
import ModalCaption from '@/components/TeacherManagement/ModalCaption.vue';
import dayjs from 'dayjs';
import {Browser} from '@capacitor/browser';
import USER_RECORD from '@/constant/userRecord.js';
import ModalJoinPvp from '@/components/Pvp/ModalJoinPvp.vue';
import ModalCreatePvp from '@/components/Pvp/ModalCreatePvp.vue';
import ModalSelectPvpAction from '@/components/Pvp/ModalSelectPvpAction.vue';
import ModalAiChat from '@/components/Modal/ModalAiChat.vue';
import ModalTimeError from '@/components/Modal/ModalTimeError.vue';
import LiveCoursePreviewModal from '@/components/Live/LiveCoursePreviewModal.vue';
import checkSystemBrowserNeedUpdate from '@/lib/base/checkSystemBrowserNeedUpdate.js';
import maintenanceService from '@/services/maintenance.js';
import VERIFICATION from '@/constant/verification';
import {TSUME_MODES} from '@/constant/chessboard';
import getDeviceInfo from '@/lib/base/getDeviceInfo.js';

const SKIP_VERIFICATION_MODAL_KEY = 'skipVerificationModal';
const SKIP_RANK_TEST_MODAL_KEY = 'skipRankTestModal';
const DEFAULT_SKIP_MODAL_RECORD_KEY = 'default';

export default {
  metaInfo() {
    return {
      title: i18n.t(manifest.name),
    };
  },
  components: {
    Navigation,
    SystemInfo,
    DataLoading,
    PassAnimation,
    Offline,
    ModalConfirm,
    SwitchCourse,
    Sidebar,
    ModalFirstLogin,
    ModalPrize,
    LandscapeReminder: () => import('@/components/Base/LandscapeReminder'),
    LocaleSheet,
    ModalPostQuestion,
    ModalVip,
    UpdateProgressBar,
    LadderRankSidebar,
    ModalCaption,
    ModalJoinPvp,
    ModalCreatePvp,
    ModalSelectPvpAction,
    ModalAiChat,
    ModalTimeError,
    LiveCoursePreviewModal,
  },
  mixins: [watchMixin],
  data() {
    return {
      modalPostQuestion: null,
      featureToggle,
      stage,
      isRedirectModalShow: false, // 分頁重複開啟modal
      isLogoutModalShow: false, // 提示被登出的modal
      isLogoutOtherModalShow: false, // 詢問是否踢掉其他登入者的modal
      isNewAppModalShow: false, // 提示有新的 app 要去更新
      isSpectateOverShow: false, // 觀戰的對局已結束的modal
      isVerificationModalShow: false, // 模擬檢定未完成modal
      isRankTestModalShow: false, // 初始棋力測驗進行中modal
      verificationModalText: '',
      appStoreUrl: '',
      defaultTransition: 'fade',
      transitionName: 'fade',
      isPassAnimation: false,
      passAnimationMode: 'game',
      passAnimationGameMode: null,
      isLeave: false,
      lastBack: 0,
      socket,
      checkPvpWatcher: null, // 檢查是否有對弈中人人對弈的vue watcher
      now: new Date().getTime(),
      BackEvent,
      platform: null,
      osVersion: null,
      isTimeError: false,
      isVerificationTimeOut: false,
    };
  },
  provide() {
    return {
      appNow: () => this.now,
    };
  },
  computed: {
    ...mapState('env', ['locale', 'localeName', 'localeList']),
    userData() {
      return this.$store.getters['user/userData'];
    },
    pendingPrize() {
      return this.$store.getters['env/pendingPrize'];
    },
    // 獎勵 modal 在 ModalBasicInfo 套用邀請碼成功後立刻顯示，
    // 不需要再判斷頁面路徑（新流程：BasicInfo → 獎勵 → RankTest banner）
    shouldShowPrize() {
      return !!this.pendingPrize;
    },
    noLandscapeReminder() {
      return this.$route?.meta?.noLandscapeReminder;
    },
    keepAliveRoute() {
      const routeName = this.$route.name;
      return [
        'practiceTsume',
        'practiceGame',
        'courseTsume',
        'courseGame',
        'ladderGame',
        'ladderEndgame',
        'ladderFuseki',
        'ladderTsume',
        'rank-test-tsume',
        'verificationGame',
        'verificationTsume',
        'pvp',
        'roomSetting',
      ].includes(routeName)
        ? ['TsumeRoom', 'GameRoom', 'Pvp']
        : [];
    },
    viewMode() {
      return this.$store.state.env.viewMode;
    },
    screenHeight() {
      return this.$store.state.env.height;
    },
    isLoading() {
      return this.$store.getters['env/isLoading'];
    },
    isLogin() {
      return this.$store.getters['user/isLogin'];
    },
    plans() {
      return this.$store.getters['course/plans'];
    },
    currentPlan() {
      return this.$store.getters['course/currentPlan'];
    },
    verificationData() {
      return this.$store.getters['verification/verificationData'] || {};
    },
    sheetHeight() {
      const sheetHeight = 50 * this.plans.length + 56;
      if (sheetHeight > this.screenHeight - 100) {
        return 'calc(100% - 100px)';
      }
      return sheetHeight + 'px';
    },
    isSwitchCourseSheetShow() {
      return this.$store.state.env.isSwitchCourseSheetShow;
    },
    isSpectate() {
      return this.$route.query.spectateId != null;
    },
    isFirstLogin() {
      return !!this.$route.query?.isFirstLogin;
    },
    rankTest() {
      const userRecordId = USER_RECORD.TYPE.RANK_TEST;
      return this.$store.getters['userRecord/getRecordData'](userRecordId);
    },
    hasShowRankTestHint() {
      const isDone = this.$store.getters['userRecord/getIsDone'](
        USER_RECORD.TYPE.RANK_TEST
      );
      return !isDone && !this.userData.rank && this.isLogin;
    },
  },
  watch: {
    locale(newLocale) {
      if (!newLocale) return;
      this.$i18n.locale = newLocale;
      if (this.$route.name && this.$route.params?.pathMatch !== newLocale) {
        this.$router.replace({
          ...this.$route,
          params: {
            ...this.$route.params,
            pathMatch: newLocale,
          },
        });
      }
    },
    $route: {
      handler() {
        const router = this.$route.name;
        if (
          socket.isInit &&
          router !== 'roomSetting' &&
          router !== socket.router
        ) {
          socket.update({router});
        }
        if (this.$route.params?.pathMatch !== this.locale) {
          this.changeLocale(this.$route.params?.pathMatch);
        }
      },
    },
    isLogin: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          if (this.checkPvpWatcher) {
            this.checkPvpWatcher();
          }
          this.checkPvpWatcher = this.waitUntil(
            {
              '$route.name': {
                $exists: true,
              },
              'socket.isInit': true,
            },
            () => {
              this.checkPvpUnfinishedGame();
            }
          );
          this.initialSocket();
          if (this.isLogin) {
            this.$store.dispatch('notification/getNotifications', 50);
            this.$store.dispatch('verification/getVerification');
            this.$store.dispatch(
              'userRecord/getUserRecordData',
              USER_RECORD.TYPE.RANK_TEST
            );
          }
        }
      },
    },
    isSpectate: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.urlToPvpRoom();
        }
      },
    },
    verificationData: {
      immediate: true,
      handler() {
        this.$router.onReady(() => {
          this.checkUnfinishedVerification();
        });
      },
    },
    hasShowRankTestHint: {
      immediate: true,
      handler(hasShowRankTestHint) {
        this.$router.onReady(() => {
          if (!hasShowRankTestHint) return;
          this.checkUnfinishedRankTest();
        });
      },
    },
  },
  async created() {
    console.log('Welcome to HJJGO! v5.5.0e');
    this.initEventBusHandler();
    const isSystemUpdate = await this.$store.dispatch(
      'maintenance/getSystemState'
    );
    if (isSystemUpdate) {
      this.$router.push({
        name: 'systemUpdate',
      });
    }

    document.documentElement.setAttribute('lang', this.locale || 'en');
    fbTrack('PageView');
    this.scheduleUpdateNow();
    const deviceInfo = await Device.getInfo();
    this.platform = deviceInfo.platform;
    this.osVersion = deviceInfo.osVersion;
    window.isApp = deviceInfo.platform !== 'web';
    this.$store.commit('env/setPlatform', deviceInfo.platform);

    await this.checkAppBuildVersion();

    if (this.platform === 'android') {
      App.addListener('backButton', this.backButtonHandler);
    }

    if (this.platform === 'web') {
      window.addEventListener(
        'resize',
        throttle(this.handleWindowResize, 1000 / 60, {leading: true})
      );
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener(
          'resize',
          throttle(this.handleWindowResize, 1000 / 60, {leading: true})
        );
      });
    }

    if (this.platform === 'ios' || this.platform === 'android') {
      window.addEventListener('orientationchange', () => {
        this.handleWindowOrientationchange();
      });
      window.addEventListener(
        'resize',
        throttle(this.handleWindowResize, 1000 / 60, {leading: true})
      );
    }

    this.handleWindowResize();

    if (this.$device.isMobile) {
      this.$router.beforeEach(async (to, from, next) => {
        if (to.name === 'roomSetting' || from.name === 'roomSetting') {
          this.transitionName = to.fullPath.includes('roomSetting')
            ? 'slide-left'
            : 'slide-right';
          next();
          return;
        }
        const fromUpperTransitionType = to.meta.fromUpperTransitionType;
        const toUpperTransitionType = from.meta.toUpperTransitionType;
        const toPathLength = to.path.split('/').length;
        const fromPathLength = from.path.split('/').length;
        const transitionType =
          toPathLength >= fromPathLength
            ? fromUpperTransitionType
            : toUpperTransitionType;
        if (
          to.meta.transitionDepth != null &&
          from.meta.transitionDepth != null
        ) {
          if (to.meta.hasPassAnimation) {
            this.transitionName = this.defaultTransition;
          } else {
            this.transitionName =
              to.meta.transitionDepth < from.meta.transitionDepth
                ? 'slide-right'
                : 'slide-left';
          }
          next();
        } else if (transitionType === 'slide') {
          this.transitionName =
            toPathLength < fromPathLength ? 'slide-right' : 'slide-left';
          next();
        } else if (
          transitionType === 'passAnimation' &&
          this.$device.isMobile
        ) {
          this.passAnimationMode = to.meta.passAnimationMode;
          if (toPathLength >= fromPathLength) {
            if (this.passAnimationMode === 'game') {
              this.passAnimationGameMode =
                to.matched?.[0]?.props?.default?.mode;
            }
            this.isPassAnimation = true;
            await delay(1000);
            next();
            if (this.passAnimationMode === 'tsume') await delay(2000);
            this.isLeave = true;
          }
        } else {
          this.transitionName = this.defaultTransition;
          next();
        }
      });
    }
    if (stage !== 'prod') {
      this.toggleCheatMode();
    }
    setTimeout(() => {
      this.checkTime();
    }, 2000);
    App.addListener('appStateChange', async (state) => {
      if (state.isActive) {
        AppEvent.setAppStateActive(true);
        const isSystemUpdate = await this.$store.dispatch(
          'maintenance/getSystemState'
        );
        if (isSystemUpdate) {
          this.$router.push({
            name: 'systemUpdate',
          });
        }
        if (this.isLogin) {
          this.$store.dispatch('notification/getNotifications', 50);
          this.$store.dispatch('verification/getVerification');
          this.$store.dispatch(
            'userRecord/getUserRecordData',
            USER_RECORD.TYPE.RANK_TEST
          );
        }
        setTimeout(() => {
          this.checkTime();
        }, 2000);
      } else {
        SoundService.stopSound();
        AppEvent.setAppStateActive(false);
      }
    });
    this.checkSystemBrowserNeedUpdate();
  },
  mounted() {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener(
      'hashchange',
      () => {
        const currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );
  },
  async beforeDestroy() {
    await App.removeAllListeners();
  },
  methods: {
    ...mapActions('env', ['changeLocale']),
    closePrizeModal() {
      this.$store.commit('env/clearPendingPrize');
    },
    waitForNextFrame() {
      return new Promise((resolve) => {
        window.requestAnimationFrame(() => resolve());
      });
    },
    async getStableWindowSize(maxFrames = 10) {
      let prevWidth = window.innerWidth;
      let prevHeight = window.innerHeight;
      let stableFrames = 0;

      for (let frame = 0; frame < maxFrames; frame += 1) {
        await this.waitForNextFrame();
        const nextWidth = window.innerWidth;
        const nextHeight = window.innerHeight;

        if (nextWidth === prevWidth && nextHeight === prevHeight) {
          stableFrames += 1;
          if (stableFrames >= 2) {
            return {width: nextWidth, height: nextHeight};
          }
        } else {
          stableFrames = 0;
          prevWidth = nextWidth;
          prevHeight = nextHeight;
        }
      }

      return {width: prevWidth, height: prevHeight};
    },
    async checkLearnPlanOrRedirect() {
      if (dayjs().isAfter(this.userData.liveCourseEndAt)) {
        this.$store.commit('env/setIsShowVipModal', true);
        return false;
      }
    },
    toggleModalPostQuestion() {
      this.$refs.modalPostQuestion.show();
    },
    initEventBusHandler() {
      // todo[perf]: 將專案中 global 事件 e.g. tab/page 等進入前的判斷合併統一到此處避免 shotgun surgery, 未來量多時可考量 by naming, files 隔離事件

      this.$eventBus.$on(
        'toggleModalPostQuestion',
        this.toggleModalPostQuestion
      );
      this.$eventBus.$on(
        'checkLearnPlanOrRedirect',
        this.checkLearnPlanOrRedirect
      );
    },
    toggleCheatMode() {
      const egg = new Egg();
      egg
        .addCode('esc,esc,esc', () => {
          this.$store.commit('env/toggleCheatMode');
        })
        .listen();
    },
    async handleWindowResize() {
      if (document.activeElement.nodeName === 'INPUT') return;
      const data = getDeviceInfo();
      this.$store.commit('env/setWindowSize', data);
      if (this.viewMode === 'phone') {
        document.body.style.height = `${this.screenHeight}px`;
      }
    },
    async handleWindowOrientationchange() {
      if (document.activeElement.nodeName === 'INPUT') return;
      await this.getStableWindowSize();
      await this.handleWindowResize();
    },
    destoryPassAnimation() {
      this.isPassAnimation = false;
      this.isLeave = false;
    },
    async backButtonHandler() {
      if (BackEvent.backEventBus.length !== 0) {
        BackEvent.emit();
        return;
      } else if (this.$route?.meta.depth === 1) {
        if (Date.now() - this.lastBack < 2000) {
          App.exitApp();
        } else {
          await Toast.show({
            text: this.$t('再按一次離開應用程式'),
          });
          this.lastBack = Date.now();
        }
      } else {
        window.history.back();
      }
    },
    initialSocket() {
      const jwt = getLocalData('jwt');

      if (jwt && !socket.isInit) {
        socket.init(jwt, this.$route.name);
        if (this.$route.name == 'home') {
          this.urlToPvpRoom();
        }
        socket.onAskIfLogoutOtherAccount(() => {
          this.isLogoutOtherModalShow = true;
        });
        socket.onLogout(() => {
          this.$nextTick(() => {
            this.logout();
            this.isLogoutModalShow = true;
          });
        });
        socket.onRedirectRouter(() => {
          this.isRedirectModalShow = true;
        });
      }
      // 監聽產品是否更新中
      socket.onUpdateEnv((result) => {
        const data = JSON.parse(result.message).isUnderMaintenance;
        this.$store.commit('maintenance/setMaintenance', data);
        if (data) {
          this.$router.push({name: 'systemUpdate'});
        } else {
          this.$router.push({name: 'home'});
        }
      });
    },
    logout() {
      this.$store.dispatch('user/logout');
    },
    logoutOtherAccount() {
      socket.sendLogoutOtherAccount();
    },
    urlToPvpRoom() {
      if (this.$route.query.pvp) {
        this.$store.commit('env/setIsLoading', true);
        socket.send({
          action: 'pvp',
          pvpAction: socket.SendEventEnum.PVP_ENTER_LOBBY,
          data: {
            lobbyId: this.$route.query.pvp,
          },
        });
        socket.once(socket.ResponseEventEnum.PVP_GAME_STARTED, () => {
          this.$store.commit('env/setIsLoading', false);
          this.$router.push('pvp');
        });
      } else if (this.isSpectate) {
        this.$store.commit('env/setIsLoading', true);
        const sendEvent = socket.SendEventEnum.PVP_SPECTATE;
        socket.send({
          action: 'pvp',
          pvpAction: sendEvent,
          data: {
            gameId: this.$route.query.spectateId,
          },
        });
        const getGameResponseEvent =
          socket.ResponseEventEnum.PVP_SPECTATE_SUCCESSFULLY;
        socket.once(getGameResponseEvent, async (result) => {
          const game = result.data;
          this.$store.commit('env/setIsLoading', false);
          if (!game.winner) {
            this.$router.push({
              name: 'pvp',
              query: {spectateId: game.gameId},
            });
          } else {
            this.$router.replace({
              name: 'home',
            });
            this.isSpectateOverShow = true;
          }
        });
      }
    },
    checkPvpUnfinishedGame() {
      if (socket.isInit && !['pvp', 'pvp-lobby'].includes(this.$route.name)) {
        socket.once(socket.ResponseEventEnum.PVP_EXIST_PVP_GAME, (result) => {
          const data = result.data;
          if (data) {
            this.$router.push('/pvp');
          }
        });
        socket.send({
          action: 'pvp',
          pvpAction: socket.SendEventEnum.PVP_GET_UNFINISHED_GAME,
        });
      }
    },
    scheduleUpdateNow() {
      if (!this.timmer) {
        this.timmer = setInterval(() => {
          this.now = new Date().getTime();
        }, 1000);
      }
    },
    openAppStore() {
      if (this.platform === 'ios') {
        window.open(this.appStoreUrl);
      } else {
        Browser.open({url: this.appStoreUrl});
      }
    },
    dateFormat(plan) {
      return this.$day(plan.startedAt).format('YYYY-MM-DD');
    },
    async closeSwitchCourseSheet() {
      BackEvent.popEvent();
      this.$store.commit('env/setIsSwitchCourseSheetShow', false);
    },

    async getAppInfo() {
      try {
        return await App.getInfo();
      } catch (error) {
        return {build: 0};
      }
    },
    async getAppConfigs() {
      const defaultValue = appConfigs || {};
      const appConfigUrl = `${url.cdn}appConfig.json?v=${Date.now()}`;
      try {
        return (await axios.get(appConfigUrl)).data || defaultValue;
      } catch (error) {
        return defaultValue;
      }
    },
    async checkAppBuildVersion() {
      const [appInfo, appConfigs] = await Promise.all([
        this.getAppInfo(),
        this.getAppConfigs(),
      ]);
      const appConfig = appConfigs?.[this.platform];
      this.appStoreUrl = appConfig?.store;
      if (appConfig && appInfo.build < appConfig.build) {
        this.isNewAppModalShow = true;
      }
    },
    async checkSystemBrowserNeedUpdate() {
      const key = 'checkSystemBrowserNeedUpdate';
      const isChecked = getDataWithExpiry(key);
      if (isChecked) return; // 三個月內已經檢查過了，避免重複檢查
      const isNeedUpdate = checkSystemBrowserNeedUpdate();
      if (!isNeedUpdate) return;
      if (this.platform === 'android') {
        const expiry = dayjs().add(3, 'M').valueOf();
        setTemporaryData(key, true, expiry);
        const osVersion = parseFloat(this.osVersion);
        let url =
          'https://play.google.com/store/apps/details?id=com.google.android.webview';
        if (osVersion < 10) {
          url =
            'https://play.google.com/store/apps/details?id=com.android.chrome';
        }
        const isConfirm = await this.$alert({
          message: this.$t('請更新系統瀏覽器以獲得更好的使用體驗'),
          confirm: this.$t('更新'),
          cancel: this.$t('取消'),
        });
        if (isConfirm) {
          window.open(url, '_system');
        }
      }
    },
    async checkTime(tryCount = 0) {
      if (this.isTimeError) return;
      if (this.isCheckingTime && tryCount === 0) return;
      this.isCheckingTime = true;
      await this.$nextTick();
      const serverTime = await maintenanceService.getServerTime();
      const localTime = Date.now();
      const diff = Math.abs(serverTime - localTime);
      if (diff > 5 * 60 * 1000) {
        if (tryCount >= 3) {
          this.isCheckingTime = false;
          this.isTimeError = true;
        } else {
          await delay(2000);
          await this.checkTime(tryCount + 1);
        }
      } else {
        this.isCheckingTime = false;
      }
    },
    checkVerificationIsOvertime(game) {
      if (!game || !game.userColor || !game.lastMoveAt) {
        return false;
      }
      const {userColor, lastMoveAt, byoYomiTime} = game;
      const mainTime = game[`${userColor}Time`] || 0;
      const byoYomiAmount = game[`${userColor}ByoYomiAmount`] || 0;

      const totalRemainingSeconds = mainTime + byoYomiTime * byoYomiAmount;
      const elapsedSeconds = (this.now - lastMoveAt) / 1000;

      return elapsedSeconds > totalRemainingSeconds;
    },
    checkRouteForProcessingModal() {
      const routeName = this.$route.name;
      const exceptRoute = [
        'practiceTsume',
        'practiceGame',
        'courseTsume',
        'courseGame',
        'rank-test-tsume',
        'rank-test-game',
        'verificationGame',
        'verificationTsume',
        'verification',
        'rank-test',
      ];
      return exceptRoute.includes(routeName);
    },
    getVerificationRecordKey() {
      const verificationId = this.verificationData?.id;
      if (!verificationId) return null;

      const rank = this.verificationData?.rank;
      const coursePlan =
        this.verificationData?.coursePlan || this.currentPlan?.id || 'unknown';

      return `${coursePlan}_${rank}_${verificationId}`;
    },
    getSkipModalRecords(storageKey, {legacyBooleanRecordKey = null} = {}) {
      const recordsString = getLocalData(storageKey);
      if (!recordsString) return {};

      try {
        const records = JSON.parse(recordsString);
        if (records && typeof records === 'object') {
          return records;
        }

        // 兼容舊版只儲存 boolean 的資料
        if (records === true && legacyBooleanRecordKey) {
          const legacyRecords = {[legacyBooleanRecordKey]: true};
          saveLocalData(storageKey, JSON.stringify(legacyRecords));
          return legacyRecords;
        }

        return {};
      } catch (error) {
        return {};
      }
    },
    hasSkippedModal(storageKey, recordKey = DEFAULT_SKIP_MODAL_RECORD_KEY) {
      if (!recordKey) return false;
      const records = this.getSkipModalRecords(storageKey);
      return records[recordKey] === true;
    },
    setSkipModal(storageKey, recordKey = DEFAULT_SKIP_MODAL_RECORD_KEY) {
      if (!recordKey) return;
      const records = this.getSkipModalRecords(storageKey);
      records[recordKey] = true;
      saveLocalData(storageKey, JSON.stringify(records));
    },
    hasSkippedVerificationModal() {
      const key = this.getVerificationRecordKey();
      if (!key) return false;

      const records = this.getSkipModalRecords(SKIP_VERIFICATION_MODAL_KEY, {
        legacyBooleanRecordKey: key,
      });
      return records[key] === true;
    },
    setSkipVerificationModal() {
      const key = this.getVerificationRecordKey();
      if (!key) return;

      this.setSkipModal(SKIP_VERIFICATION_MODAL_KEY, key);
    },
    hasSkippedRankTestModal() {
      return this.hasSkippedModal(SKIP_RANK_TEST_MODAL_KEY);
    },
    setSkipRankTestModal() {
      this.setSkipModal(SKIP_RANK_TEST_MODAL_KEY);
    },
    checkUnfinishedVerification() {
      const isOnExceptRoute = this.checkRouteForProcessingModal();
      this.isVerificationTimeOut = false;
      if (isOnExceptRoute) {
        this.isVerificationModalShow = false;
        return;
      }
      const verificationState = this.verificationData?.state;
      const isPlaying = verificationState === VERIFICATION.STATE.PLAYING;
      const isTsumePlaying =
        this.verificationData?.tsume?.find(
          (item) => item.state === VERIFICATION.STATE.PLAYING
        ) != null;
      const isGamePlaying =
        this.verificationData?.game?.list.find(
          (item) => item.state === VERIFICATION.STATE.PLAYING
        ) != null;
      let isTimeOut = false;
      if (isGamePlaying) {
        const currentGame = this.verificationData?.game?.list.find(
          (item) => item.state === VERIFICATION.STATE.PLAYING
        );
        isTimeOut = this.checkVerificationIsOvertime(currentGame?.record);
      }

      if (isPlaying && (isTsumePlaying || (isGamePlaying && !isTimeOut))) {
        if (this.hasSkippedVerificationModal()) {
          this.isVerificationModalShow = false;
          return;
        }
        this.verificationModalText =
          this.$t('模擬檢定尚未結束，要前往完成嗎？');
        this.isVerificationModalShow = true;
      } else if (isPlaying && isTimeOut) {
        this.isVerificationTimeOut = true;
        this.verificationModalText =
          this.$t('模擬檢定項目已結束，請查看結果。');
        this.isVerificationModalShow = true;
      } else {
        this.isVerificationModalShow = false;
      }
    },
    async checkUnfinishedRankTest() {
      const isOnExceptRoute = this.checkRouteForProcessingModal();
      if (isOnExceptRoute) {
        this.isRankTestModalShow = false;
        return;
      }
      if (this.isVerificationModalShow) return;
      if (!this.hasShowRankTestHint) return;
      if (this.hasSkippedRankTestModal()) {
        this.isRankTestModalShow = false;
        return;
      }
      // 檢查是否有未完成的初始棋力測驗
      if (!this.rankTest?.tsume) {
        // 檢查未完成的做題
        const unfinishedTsume = await this.$store.dispatch(
          'tsumeGame/getUnfinishedTsume',
          TSUME_MODES.RANK_TEST
        );
        if (unfinishedTsume) this.isRankTestModalShow = true;
      }
    },
    go2Verification() {
      this.isVerificationModalShow = false;
      this.$router.push({name: 'verification', query: {from: 'modal'}});
    },
    skipVerificationModal() {
      this.isVerificationModalShow = false;
      this.setSkipVerificationModal();
    },
    skipRankTestModal() {
      this.isRankTestModalShow = false;
      this.setSkipRankTestModal();
    },
    go2RankTest() {
      this.isRankTestModalShow = false;
      this.$router.push({name: 'rank-test', query: {from: 'modal'}});
    },
  },
};
</script>

<style lang="scss">
html {
  font-size: 16px !important;
  position: fixed;
  width: 100%;
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}

body {
  height: 100vh;
  height: 100dvh;
  position: relative;
  overflow: hidden;
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}

#app {
  box-shadow: 0px 0px 1px 1px #dcdfe5;
}

.grecaptcha-badge {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}
.sheet-option {
  height: 50px;
  &.disabled {
    color: $font-grayscale-3;
  }
  &:not(:last-child) {
    border-bottom: 1px solid $line-2;
  }
  .icon-Check {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    font-size: 32px;
    color: $primary;
  }
}

// DEFAULT_TRANSITION
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
// SLIDE_TRANSITION
main {
  display: grid;
  grid-template: 'main';
  flex: 1;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 6;
  background-color: $bgcontainer;
}

main > * {
  grid-area: main; /* Transition: make sections overlap on same cell */
  // flex: 1 1 auto;
  background-color: $bgcontainer;
  position: relative;
  // height: 100%; /* To be fixed */
  touch-action: manipulation;
}

main > :first-child {
  z-index: 9; /* Prevent flickering on first frame when transition classes not added yet */
}

.slide-left-leave-to {
  animation: delayHide 0.01s 300ms forwards;
  animation: leaveToLeft 300ms both ease;
  z-index: 6;
}

.slide-left-enter-to {
  animation: delayHide 0.01s forwards;
  animation: enterFromRight 300ms both ease;
  z-index: 12;
}

.slide-right-leave-to {
  animation: delayHide 0.01s forwards;
  animation: leaveToRight 300ms both ease;
  z-index: 12;
}

.slide-right-enter-to {
  animation: delayHide 0.01s 300ms forwards;
  animation: enterFromLeft 300ms both ease;
  z-index: 6;
}
@keyframes delayShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes delayHide {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-50%);
    filter: brightness(0.5);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
.ai-tutor {
  &.is-mobile {
    width: 55px;
    height: 55px;
    bottom: 8px;
    right: 8px;
  }
  &-container {
    border: 2px solid $secondary;
    position: fixed;
    width: 380px;
    height: 670px;
    max-height: calc(100% - 32px);
    right: 18px;
    bottom: 13px;
    z-index: 9;
    border-radius: $rounded-md;
    background: $color-gray-white;
    overflow: hidden;
    &-header {
      background: $secondary;
      color: $color-gray-white;
      height: 56px;
      line-height: 56px;
      text-align: center;
      font-size: 18px;
    }
    &-close-button {
      position: absolute;
      z-index: 100;
      top: 13px;
      right: 13px;
      font-size: 32px;
      color: $color-gray-white;
    }
  }
}
.plan-wrapper {
  width: 600px;
  height: 500px;
  border-radius: 10px;
  background: white;
  overflow: hidden;
  .plan-icon {
    font-size: 32px;
    color: #ff855e;
    cursor: pointer;
  }
  .plan-header {
    display: flex;
    justify-content: space-between;
    padding: 15px 12px 15px 16px;
    height: 60px;
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: 0px;
    color: #606266;
    border-bottom: 1px solid #ced4da;
  }
  .plan-body {
    padding: 16px;
    width: 100%;
  }
  .plan-frame {
    width: 568px;
    height: 406px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    overflow: hidden;
  }
}

.list-group {
  .list-group-item-action {
    height: 51px;
    border-bottom: 1px solid rgba(199, 199, 199, 0.3);
    color: $font-normal;
  }
}

.locale-box {
  // feat: for dev/beta testing
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 10000;
}
.ai-tutor-container {
  .icon-X {
    cursor: pointer;
  }
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

input[type='date']:before {
  color: #848688;
  content: attr(placeholder) !important;
  display: block;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5rem;
  position: absolute;
  background: white;
  pointer-events: none;
}

input[type='date']:focus:before {
  content: '' !important;
  visibility: hidden !important;
}

:root {
  --safe-area-bottom: env(safe-area-inset-bottom);
  --safe-area-top: env(safe-area-inset-top);
  --safe-area-left: env(safe-area-inset-left);
  --safe-area-right: env(safe-area-inset-right);
}
</style>
